import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import _ from 'lodash'
import Loader from '@app/components/ui/placeholders/Loader'
import * as parentActions from '@app/actions/parents'

class StatisticsContainer extends Component {
  constructor(props) {
    super(props)

    const { dispatch } = props
    this.boundActions = bindActionCreators(parentActions, dispatch)
  }

  componentDidMount() {
    this.updateIfNeeded()
  }

  updateIfNeeded() {
    this.boundActions.fetchStatisticsIfNeeded()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.route != this.props.route) {
      this.updateIfNeeded()
    }
  }

  render() {
    const { ChildComponent, statistics, ...rest } = this.props
    if (statistics.fetching) { return <Loader /> }

    return (<ChildComponent statistics={statistics} {...rest} />)
  }
}

const mapStateToProps = (state) => {
  const { parents: { statistics }, global: { olympiads } } = state;
  return { statistics, olympiads }
}

const mapDispatchToProps = (dispatch) => {
  return { dispatch }
}

StatisticsContainer.propTypes = {
  ChildComponent: PropTypes.any.isRequired
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null, {
    getDisplayName: () => 'Statistics'
  }
)(StatisticsContainer)
